import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {ReportsService}
 */
export default class ReportsService{

    constructor() {
        this.resource = "/reports"
        this.http = Rest2.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_compiled() {
        return this.http.get("/compiled");
    }

    get_platform(platform){
        return this.http.get(`/platform/notreleased/${platform}`)
    }
}